// extracted by mini-css-extract-plugin
export default {"footer":"index_footer__O6iYc","footerTop":"index_footerTop__85T86","footerIem":"index_footerIem__ZFUkD","footerBottom":"index_footerBottom__BzwYk"};